import { render, staticRenderFns } from "./ContractorTagsSelector.vue?vue&type=template&id=53ef5c14"
import script from "./ContractorTagsSelector.vue?vue&type=script&lang=ts"
export * from "./ContractorTagsSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53ef5c14')) {
      api.createRecord('53ef5c14', component.options)
    } else {
      api.reload('53ef5c14', component.options)
    }
    module.hot.accept("./ContractorTagsSelector.vue?vue&type=template&id=53ef5c14", function () {
      api.rerender('53ef5c14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/autocompleteMultiselects/ContractorTagsSelector.vue"
export default component.exports